import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {

  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-center"
    >
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/212663391500" // Replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-400 to-green-600 text-white rounded-full shadow-lg transition transform hover:scale-105 hover:shadow-xl duration-300"
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
};

export default WhatsAppButton;
